import React from 'react'
import styled from 'styled-components'

const StyledCard = styled.div`
    border: 16px groove #3395A4;
    border-radius: 40px 0px 40px 0px;
    text-align:center;
`

const Cards = props => {
    const {data} = props
    console.log(data)


        return(
            <StyledCard>
                <h2>Event:{data.event_name}</h2>
                <h2>Date:{data.date}</h2>
                <h2>Description:{data.description}</h2>
                <h2>Organizer:{data.organizer_id}</h2>
                <h2>Event Id:{data.id}</h2>
                <h2>Time:{data.time}</h2>
            </StyledCard>
        )

}

export default Cards